import React, { Component, useState, useMemo } from "react";

import DefaultDataGrid from '../components/DefaultDataGrid';
import { Stack } from '@mui/system';
import { Checkbox, TextField, Typography, FormControlLabel, Grid } from '@mui/material';
import AutocompleteText from "./AutocompleteText";

export default function InputColumnexport(props) {
    const dataReference = { "ref": props.data };
    const [data, setData] = useState(props.data);
    const [fields, setFields] = useState({});
    props.fields.map(e => fields[e.props.name] = data[e.props.name])
    const setInputValue = props.setInputValue ? props.setInputValue : (inputName, value) => {
        // console.log(data)
        console.log(inputName, value)
        data[inputName] = value;
        dataReference['ref'][inputName] = value;
        setData({ ...data });
        // console.log(dataReference)
    };;
    // console.log(data, props.data)
    return (
        <Grid xs={props.xs ? props.xs : 4} item sx={props.sx} className={props.className}>
            <Stack spacing={2}>
                <Typography variant="h6" textAlign="left">
                    {props.title && props.title}
                </Typography>
                {props.fields.map((e, index) => {
                    //console.log(e, data)
                    if (!data[e.props.name] || (props.useDatanameFirst && data[e.props.dataname] != undefined)) {
                        if (e.props.dataname) {
                            data[e.props.name] = data[e.props.dataname];
                            delete data[e.props.dataname];
                        } else {
                            data[e.props.name] = data[e.props.name];
                        }
                    }
                    let value;
                    if (e.type == AutocompleteText) value = data[e.props.name + "_autocomplete"] ? data[e.props.name + "_autocomplete"] : (data[e.props.name] ? data[e.props.name] : e.props.value);
                    else value = data[e.props.name];
                    if (!value) value = "";
                    console.log(data)
                    if (e.type == Checkbox) {
                        console.log(value)
                        return (<FormControlLabel
                            sx={{ alignSelf: "start" }}
                            control={<e.type checked={Boolean(value)} name={e.props.name} sx={{ padding: "0px" }} value={Boolean(value)} />}
                            label={e.props.label}
                            key={e.props.label}
                            labelPlacement="start"
                            disabled={props.disabled}
                            onChange={(event) => {
                                console.log(event.target.name, event.target.checked)
                                console.log(event.target.value)
                                setInputValue(event.target.name, event.target.checked)
                            }} />)
                    }
                    return (
                        <e.type
                            setinputvalue={(e.type == AutocompleteText) ? setInputValue : ''}
                            fullWidth
                            disabled={props.disabled}
                            {...e.props}
                            value={value}
                            onChange={(event, value) => {
                                setInputValue(event.target.name, event.target.value)
                                if (e.props.onChange) e.props.onChange(event, value, setInputValue)
                            }}
                            size="small" key={`${index}.${e.props.name}`} variant="outlined"
                        />
                    )
                }
                )}
            </Stack>
        </Grid >
    )
}